import { hyperdbHandlers } from 'hyperdb-utils';

export default hyperdbHandlers({ namespace: 'ZONE' });



// WEBPACK FOOTER //
// ./src/frontend/modules/inventory/zone/handlers.js